import { render, staticRenderFns } from "./StudentCheckExamination.vue?vue&type=template&id=50496ecf"
import script from "./StudentCheckExamination.vue?vue&type=script&lang=js"
export * from "./StudentCheckExamination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports